module.exports = __webpack_public_path__ + "img/HalimYusuf.d0a4c422.jpg";